<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="3" xs="12">
        <BaseSelect :options="userNameSelect.options" :data="userNameSelect.data"
                    ref="userNameSelect"></BaseSelect>
      </CCol>
      <CCol sm="2" xs="12">
        <BaseSelect :options="typeSelect.options" :data="typeSelect.data"
                    ref="typeSelect"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #timeAction="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.timeAction) }}
            </td>
          </template>
          <template #type="{item}">
            <td>
                <span v-if="item.type == 0" class="badge badge-warning">
                Tài khoản
              </span>
              <span v-else class="badge badge-info">
                Hệ thống
              </span>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "UsersActionLogList",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      userNameSelect: {
        options: {
          filter: true,
          label: 'Tài khoản',
          'keyField': 'value',
          'valueField': 'text',
          selectAllText: "Tất cả tài khoản"
        },
        data: {
          name: "user_id",
          model: "",
          source: {
            url: "/users/list-user-active",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      typeSelect: {
        options: {
          filter: false,
          label: 'Loại thao tác',
        },
        data: {
          name: "type",
          items: [
            {key: "null", value: "Tất cả loại thao tác"},
            {key: "0", value: "Tài khoản"},
            {key: "1", value: "Hệ thống"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "userName", label: "Tài khoản"},
            {key: "nameAction", label: "Tên thao tác"},
            {key: "ipAction", label: "IP thao tác"},
            {key: "timeAction", label: "Thời gian thao tác"},
            {key: "type", label: "Loại thao tác"},
          ],
          slots: ["index", "timeAction", "type"],
          pageSize: 15,
        },
        dataSource: {
          url: "/user-action-log/page-user-action-log",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
